import type { NavigationGuard } from '#vue-router';
import { useIsFeatureEnabled } from '~/composables/useIsFeatureEnabled';
import type { FeatureFlag } from '~/plugins/featureFlags';

export const createFeatureFlagMiddleware = (featureName: FeatureFlag): NavigationGuard => () => {
	if (useIsFeatureEnabled(featureName).value) {
		return;
	}

	return navigateTo('/');
};
